var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_3012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.125 41.25H5.625C5.12772 41.25 4.65081 41.0525 4.29917 40.7008C3.94754 40.3492 3.75 39.8723 3.75 39.375V1.875C3.75 1.37772 3.55246 0.900806 3.20083 0.549175C2.84919 0.197544 2.37228 0 1.875 0C1.37772 0 0.900806 0.197544 0.549175 0.549175C0.197544 0.900806 0 1.37772 0 1.875L0 39.375C0 40.8668 0.592632 42.2976 1.64752 43.3525C2.70242 44.4074 4.13316 45 5.625 45H43.125C43.6223 45 44.0992 44.8025 44.4508 44.4508C44.8025 44.0992 45 43.6223 45 43.125C45 42.6277 44.8025 42.1508 44.4508 41.7992C44.0992 41.4475 43.6223 41.25 43.125 41.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 37.5C28.6223 37.5 29.0992 37.3025 29.4508 36.9508C29.8025 36.5992 30 36.1223 30 35.625V22.5C30 22.0027 29.8025 21.5258 29.4508 21.1742C29.0992 20.8225 28.6223 20.625 28.125 20.625C27.6277 20.625 27.1508 20.8225 26.7992 21.1742C26.4475 21.5258 26.25 22.0027 26.25 22.5V35.625C26.25 36.1223 26.4475 36.5992 26.7992 36.9508C27.1508 37.3025 27.6277 37.5 28.125 37.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 37.5C13.6223 37.5 14.0992 37.3025 14.4508 36.9508C14.8025 36.5992 15 36.1223 15 35.625V22.5C15 22.0027 14.8025 21.5258 14.4508 21.1742C14.0992 20.8225 13.6223 20.625 13.125 20.625C12.6277 20.625 12.1508 20.8225 11.7992 21.1742C11.4475 21.5258 11.25 22.0027 11.25 22.5V35.625C11.25 36.1223 11.4475 36.5992 11.7992 36.9508C12.1508 37.3025 12.6277 37.5 13.125 37.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 37.5C36.1223 37.5 36.5992 37.3025 36.9508 36.9508C37.3025 36.5992 37.5 36.1223 37.5 35.625V13.125C37.5 12.6277 37.3025 12.1508 36.9508 11.7992C36.5992 11.4475 36.1223 11.25 35.625 11.25C35.1277 11.25 34.6508 11.4475 34.2992 11.7992C33.9475 12.1508 33.75 12.6277 33.75 13.125V35.625C33.75 36.1223 33.9475 36.5992 34.2992 36.9508C34.6508 37.3025 35.1277 37.5 35.625 37.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 37.5C21.1223 37.5 21.5992 37.3025 21.9508 36.9508C22.3025 36.5992 22.5 36.1223 22.5 35.625V13.125C22.5 12.6277 22.3025 12.1508 21.9508 11.7992C21.5992 11.4475 21.1223 11.25 20.625 11.25C20.1277 11.25 19.6508 11.4475 19.2992 11.7992C18.9475 12.1508 18.75 12.6277 18.75 13.125V35.625C18.75 36.1223 18.9475 36.5992 19.2992 36.9508C19.6508 37.3025 20.1277 37.5 20.625 37.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_3012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGraph);
export default __webpack_public_path__ + "static/media/barGraph.27cb0a86.svg";
export { ForwardRef as ReactComponent };